class TruckConfiguratorStore {
    _configurationData;
    _featureIds = [];
    _stepAmount = null;
    _fallbackInterval = null;
    _selectedCommercialSpecId;
    _answerOrderList = '';

    constructor() {
        if (TruckConfiguratorStore.instance) {
            return TruckConfiguratorStore.instance;
        }
        TruckConfiguratorStore.instance = this;
    }

    get configurationData() {
        return this._configurationData;
    }

    set configurationData(data) {
        this._configurationData = data;
    }

    get featureIds() {
        return this._featureIds;
    }

    set featureIds(data) {
        this._featureIds = data;
    }

    get stepAmount() {
        return this._stepAmount;
    }

    set stepAmount(amount) {
        this._stepAmount = amount;
    }

    get fallbackInterval() {
        return this._fallbackInterval;
    }

    set fallbackInterval(interval) {
        this._fallbackInterval = interval;
    }

    get selectedCommercialSpecId() {
        return this._selectedCommercialSpecId;
    }

    set selectedCommercialSpecId(id) {
        this._selectedCommercialSpecId = id;
    }

    get answerOrderList() {
        return this._answerOrderList;
    }

    set answerOrderList(list) {
        this._answerOrderList = list;
    }
}

export default TruckConfiguratorStore;